import { Product } from '../product/Product'
import { Prop } from '@typegoose/typegoose'
import { Field, ID, Float, ObjectType, InputType } from 'type-graphql'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'
import { UnitOfMeasure } from '../unitOfMeasure/UnitOfMeasure'

@ObjectType()
@InputType('PurchaseOrderItemInput')
export class PurchaseOrderItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('poit') })
  _id: string

  @Field(() => Product)
  @Prop({ type: () => RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * Snapshot of the product's purchase UOM at the time of PO creation.
   * Used for display and conversion when receiving inventory.
   */
  @Field(() => UnitOfMeasure, { nullable: true })
  @Prop({ type: () => UnitOfMeasure })
  uom?: ReturnType<() => UnitOfMeasure>

  @Field(() => String)
  @Prop({ type: String })
  vendorProductCode: string

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => Float)
  @Prop({ type: Number })
  price: number

  @Field(() => Float)
  @Prop({ type: Number })
  net: number

  @Field(() => Float)
  @Prop({ type: Number })
  gross: number

  @Field(() => Float)
  @Prop({ type: Number })
  discount: number //amount to be discounted, not percent

  @Field(() => Float)
  @Prop({ type: Number })
  originalPrice: number

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => [String])
  @Prop({ type: [String] })
  tags: string[]

  @Field(() => Float)
  @Prop({ type: Number })
  inventoryCount: number
}
